<!--
 * @Description: 排考管理 详情
 * @Author: PF
 * @Date: 2024-01-12 14:52:16
 * @LastEditors: PF
 * @LastEditTime: 2025-07-17 15:12:48
-->
<template>
  <div>
    <el-dialog class="wp80 hp90" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-container>
        <el-header class="pl0 pr0">
          <!-- 按钮区域 BEGIN -->
          <div class="button-box">
            <span class="title">统一时间考试科目</span>
          </div>
          <!-- 按钮区域 END -->
        </el-header>
        <el-main class="pl0 pr0">
          <el-table :data="ksccData.listTongYi" height="100%" :span-method="tysjSpanMethod" border stripe>
            <!-- 冻结列-Left BEGIN -->
            <el-table-column label="考场号" prop="kch" fixed align="center" min-width="80" />
            <el-table-column label="地点" prop="kccdmc" fixed align="center" min-width="150" />
            <el-table-column label="考生/容纳" prop="" fixed align="center" min-width="100">
              <template #default="scope">
                {{ scope.row.ckxsrs }}<span v-if="scope.row.ckxsrs !== null && scope.row.rnksrs !== null">/</span>{{ scope.row.rnksrs }}
              </template>
            </el-table-column>
            <el-table-column label="起止考号" prop="" fixed align="center" min-width="150">
              <template #default="scope">
                {{ scope.row.qskh }}<span v-if="scope.row.qskh !== null && scope.row.jskh !== null">~</span>{{ scope.row.jskh }}
              </template>
            </el-table-column>
            <el-table-column label="教学计划实施方案" prop="jxjhid" fixed align="center" min-width="200">
              <template #default="scope">
                <div>{{scope.row.jxjhmc}}</div>
              </template>
            </el-table-column>

            <el-table-column v-for="(item, index) in tysjccData" :key="index" align="center" min-width="150">
              <template #header>
                <el-tooltip class="box-item" placement="top">
                  <template #content><div style="text-align: center;">{{item.rq}}<br><div>{{item.kssj}}~{{item.jssj}}</div></div></template>
                  <span>第{{item.ccs}}场</span>
                </el-tooltip>
              </template>
              <template #default="scope">
                <div v-for="(value, i) in scope.row.listKmcc" :key="i">
                  <div v-if="value.ccid === item.id">
                    <div class="mb5">{{value.kskmmc}}</div>
                    <span v-for="(val, v) in value.listJkjs" :key="v">
                      <span v-if="v>0">、</span>
                      <span>{{val.jsxm}}</span>
                    </span>
                  </div>
                </div>
              </template>
            </el-table-column>

            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="100" fixed="right" align="center">
              <template #default="scope">
                <el-button link type="success" @click="ckksClick(scope.row)">查看考生</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
      </el-container>
      <el-container>
        <el-header class="pl0 pr0">
          <div class="search-box">
            <span class="title">非统一时间考试科目</span>
          </div>
        </el-header>
        <el-main class="pl0 pr0">
          <el-table class="fei-tong-yi" :data="ksccData.listFeiTongYi" height="100%" :span-method="ftysjSpanMethod" border stripe :cell-style="cellStyle">
            <!-- 冻结列-Left BEGIN -->
            <el-table-column label="考场号" prop="kch" fixed align="center" min-width="80" />
            <el-table-column label="地点" prop="kccdmc" fixed align="center" min-width="150" />
            <el-table-column label="教学计划实施方案" prop="jxjhid" fixed align="center" min-width="200">
              <template #default="scope">
                <div>{{scope.row.jxjhmc}}</div>
              </template>
            </el-table-column>
            <el-table-column label="考试科目" prop="kskmmc" fixed align="center" min-width="200" />
            <!-- 统一时间 -->
            <el-table-column v-for="(item, index) in tysjccData" :key="index" align="center" min-width="150">
              <template #header>
                <el-tooltip class="box-item" placement="top">
                  <template #content><div style="text-align: center;">{{item.rq}}<br><div>{{item.kssj}}~{{item.jssj}}</div></div></template>
                  <span>第{{item.ccs}}场</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <!-- 非统一时间 -->
            <el-table-column v-for="(item, index) in ftysjccData" :key="index" align="center" min-width="150">
              <template #header>
                <el-tooltip class="box-item" placement="top">
                  <template #content><div style="text-align: center;">{{item.rq}}<br><div>{{item.kssj}}~{{item.jssj}}</div></div></template>
                  <span>第{{item.ccs}}场</span>
                </el-tooltip>
              </template>
              <template #default="scope">
                <div v-for="(value, i) in scope.row.listKmcc" :key="i">
                  <div v-if="value.ccid === item.id">
                    <div><span v-if="value.qskh && value.jskh">考号</span>{{ value.qskh }}<span v-if="value.qskh && value.jskh">~</span>{{ value.jskh }}</div>
                    <span v-for="(val, v) in value.listJkjs" :key="v">
                      <span v-if="v>0">、</span>
                      <span>{{val.jsxm}}</span>
                    </span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="100" fixed="right" align="center">
              <template #default="scope">
                <el-button link type="success" @click="ckksClick(scope.row)">查看考生</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
      </el-container>
    </el-dialog>
  </div>
  <shezhi v-if="openSheZhi" v-model:openSheZhi="openSheZhi" :row="rowSheZhi" @ReturnData="initList" />
  <shezhifeitongyi v-if="openSzFty" v-model:openSzFty="openSzFty" :row="rowSzFty" @ReturnData="initList" />
  <kaochangtongyi v-if="openKcTy" v-model:openKaoChang="openKcTy" :row="rowKcTy" @ReturnData="initList" />
  <kaochangfeitongyi v-if="openKcFty" v-model:openKaoChang="openKcFty" :row="rowKcFty" @ReturnData="initList" />
  <chakankaosheng v-if="openChaKanKaoSheng" v-model:openChaKanKaoSheng="openChaKanKaoSheng" :row="rowChaKanKaoSheng" @ReturnData="initList" />

  <zidongfenpeikaochangdidian v-if="openZdfpkcdd" v-model:openZdfpkcdd="openZdfpkcdd" :row="rowZdzsksdd" @ReturnData="initList" />
  <zidongfenpeijiankaojiaoshi v-if="openfpjkjsClick" v-model:openfpjkjsClick="openfpjkjsClick" :row="rowfpjkjsClick" @ReturnData="initList" />
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, computed } from 'vue'
import { actionPost, loadSelect, closeWindow } from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo.js'
import { getRowspanMethod } from '@/utils/index.js'
import shezhi from './shezhi'
import kaochangtongyi from './kaochangtongyi'
import kaochangfeitongyi from './kaochangfeitongyi'
import shezhifeitongyi from './shezhifeitongyi'
import chakankaosheng from './chakankaosheng'
import zidongfenpeikaochangdidian from './zidongfenpeikaochangdidian.vue'
import zidongfenpeijiankaojiaoshi from './zidongfenpeijiankaojiaoshi.vue'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDetail', 'ReturnData'])

const row = ref()
const ksccData = ref({ listTongYi: [], listFeiTongYi: [] })
const initList = async () => {
  const o = {
    url: '/api/v2/jiaowu/kaowukaoshijihuapaikao/kaochangkemuchangci',
    data: { ksjhid: row.value.ksjhid, pkjhid: row.value.id, order: 'kccdmc', sort: 'asc' }
  }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      ksccData.value = res.data
    } else {
      warningPrompt(res.message)
    }
  })
}
// 获取考场
const tysjccData = ref([]) // 统一
const ftysjccData = ref([]) // 非统一
const initChangCiList = async () => {
  // 统一
  loadSelect({
    url: '/api/v2/jiaowu/kaowukaoshijihuapaikao/tongyishijiankaoshichangci',
    data: tysjccData,
    parms: { ksjhid: row.value.ksjhid, pkjhid: row.value.id },
    order: 'ccs',
    sort: 'asc',
    loadSuccess: function (res) {
      res.data.map((item) => {
        item.rq = item.ksjssj.substring(0, 10)
        item.kssj = item.ksjssj.substring(11, 16)
        item.jssj = item.kskssj.substring(11, 16)
        item.lb = 'ty'
        return item
      })
      tysjccData.value = res.data
    }
  })
  // 非统一
  loadSelect({
    url: '/api/v2/jiaowu/kaowukaoshijihuapaikao/feitongyishijiankaoshichangci',
    data: ftysjccData,
    parms: { ksjhid: row.value.ksjhid, pkjhid: row.value.id },
    order: 'ccs',
    sort: 'asc',
    loadSuccess: function (res) {
      res.data.map((item) => {
        item.rq = item.ksjssj.substring(0, 10)
        item.kssj = item.ksjssj.substring(11, 16)
        item.jssj = item.kskssj.substring(11, 16)
        item.lb = 'fty'
        return item
      })
      ftysjccData.value = res.data
    }
  })
}
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      row.value = props.row
      initChangCiList()
      initList()
    }
  },
  { deep: true, immediate: true }
)
const openKcTy = ref(false)
const rowKcTy = ref()
const openKcFty = ref(false)
const rowKcFty = ref()
// 纵向合并单元格 统一
const tysjSpanMethod = computed(() => getRowspanMethod(ksccData.value.listTongYi, ['jxjhid']))
// 纵向合并单元格 非统一
const ftysjSpanMethod = computed(() => getRowspanMethod(ksccData.value.listFeiTongYi, ['jxjhid']))

// 改变指定列背景色
const cellStyle = ({ columnIndex }) => {
  if (columnIndex >= 4 && columnIndex <= tysjccData.value.length + 3) {
    return { 'background-color': '#CDD0D6' }
  }
}
// 查看考生
const openChaKanKaoSheng = ref(false)
const rowChaKanKaoSheng = ref()
const ckksClick = (row) => {
  openChaKanKaoSheng.value = true
  rowChaKanKaoSheng.value = JSON.parse(JSON.stringify(row))
}

</script>
<style lang="less" scoped>
.el-dialog__body {
  width: 100%;
  height: calc(100% - 66px);
  overflow: auto;
}
:deep(.el-container.is-vertical) {
  height: 50%;
}
.button-box {
  .title {
    color: var(--el-text-color-primary);
    font-size: 16px;
    font-weight: 700;
  }
  display: flex;
  justify-content: space-between;
  .el-button {
    width: 130px;
  }
}
.search-box {
  .title {
    color: var(--el-text-color-primary);
    font-size: 16px;
    font-weight: 700;
  }
}
.fei-tong-yi {
  :deep(.el-table .el-table__cell) {
    padding: 0;
    // padding: 8px 0;
  }
  :deep(.el-table .cell) {
    padding: 0;
    // padding: 0 12px;
  }
}
</style>
